import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Footer, Header } from "../../components";
import { get_events } from "../../apis/Dashboard";
import { C, FONT, container } from "../../constants/mq";

// Events listing, driven by the same feed the portal uses. There are no
// events published at the moment, so the empty state has to read as
// deliberate rather than broken.

const s = {
  hero: {
    background: `linear-gradient(112deg, ${C.bright} 0%, ${C.bright} 66%, #C2001A 66%, #C2001A 100%)`,
    color: "#fff",
    padding: "58px 0 54px",
    fontFamily: FONT,
  },
  container,
  eyebrow: {
    display: "inline-block", fontSize: 12.5, fontWeight: 600, letterSpacing: "1.2px",
    textTransform: "uppercase", color: "rgba(255,255,255,0.85)", margin: "0 0 14px",
  },
  h1: {
    fontSize: 40, fontWeight: 800, letterSpacing: "-0.5px", margin: 0, lineHeight: 1.18,
    color: "#fff", maxWidth: 680,
  },
  lead: { fontSize: 15.5, lineHeight: 1.65, color: "rgba(255,255,255,0.92)", margin: "14px 0 0", maxWidth: 620 },
  body: { padding: "56px 0 80px", background: "#fff", fontFamily: FONT },
  list: { display: "flex", flexDirection: "column", gap: 12 },
  card: {
    padding: "20px 22px", display: "flex", justifyContent: "space-between",
    alignItems: "center", gap: 16, flexWrap: "wrap",
  },
  cardTitle: { fontSize: 16, fontWeight: 700, color: C.ink, margin: "0 0 4px" },
  cardMeta: { fontSize: 13, color: C.muted, margin: 0 },
  empty: { padding: "48px 24px", textAlign: "center" },
  emptyTitle: { fontSize: 17, fontWeight: 700, color: C.ink, margin: "0 0 8px" },
  emptyBody: { fontSize: 14, color: C.muted, margin: "0 0 20px" },
};

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    get_events()
      .then((res) => {
        if (!alive) return;
        setEvents(Array.isArray(res?.data) ? res.data : []);
      })
      .finally(() => alive && setLoaded(true));
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div style={{ background: "#fff" }}>
      <Header />
      <main>
        <section style={s.hero}>
          <div style={s.container}>
            <span style={s.eyebrow}>Events</span>
            <h1 style={s.h1}>Information sessions and school events</h1>
            <p style={s.lead}>
              Upcoming sessions across our campuses. Registration opens with
              each event.
            </p>
          </div>
        </section>

        <section style={s.body}>
          <div style={s.container}>
            {!loaded ? null : events.length > 0 ? (
              <div style={s.list}>
                {events.map((e, i) => (
                  <div key={e.id || i} className="mq-card" style={s.card}>
                    <div>
                      <h2 style={s.cardTitle}>{e.title || e.name}</h2>
                      <p style={s.cardMeta}>
                        {[e.event_date || e.date, e.location || e.venue]
                          .filter(Boolean)
                          .join("  ·  ")}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="mq-sand" style={s.empty}>
                <h2 style={s.emptyTitle}>No events scheduled right now</h2>
                <p style={s.emptyBody}>
                  Nothing is on the calendar at the moment. Get in touch and we
                  will let you know when the next session is announced.
                </p>
                <Link className="mq-btn" to="/contact-us">
                  Contact us
                </Link>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Events;
